import findFor from './find-for';

export default {
  findFor,
};
